export const LAST_VERIFICATION_DETAILS_SUBMISSION_TIME_KEY = 'LAST_VERIFICATION_DETAILS_SUBMISSION_TIME_KEY';
